/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { Link } from "react-scroll";

const nav = css`
  font-family: "Merienda One", serif;
  margin-top: 20px;

  a,
  span {
    font-size: 1.25rem;
    margin: 0 6px;
    cursor: pointer;
  }

  section {
    max-width: 800px;
    margin: 0 auto;
  }
`;

export default () => (
  <nav css={nav}>
    <section>
      <span>&bull;</span>
      <Link
        activeClass="active"
        to="music"
        spy={true}
        smooth={true}
        duration={500}
        containerId="main"
        offset={-140}
        isDynamic
      >
        Music
      </Link>
      <span>&bull;</span>
      <Link
        activeClass="active"
        to="videos"
        spy={true}
        smooth={true}
        duration={500}
        containerId="main"
        offset={-140}
        isDynamic
      >
        Videos
      </Link>
      <span>&bull;</span>
      <Link
        activeClass="active"
        to="gallery"
        spy={true}
        smooth={true}
        duration={500}
        containerId="main"
        offset={-140}
        isDynamic
      >
        Gallery
      </Link>
      <span>&bull;</span>
      <Link
        activeClass="active"
        to="about"
        spy={true}
        smooth={true}
        duration={500}
        containerId="main"
        offset={-140}
        isDynamic
      >
        About
      </Link>
      <span>&bull;</span>
    </section>
  </nav>
);
